import React, { useRef } from "react";

import IconMC from "../../../presentation/components/IconMC";

import { iconMapping } from "./utils";

const StepHeader = ({
  chatbotOption,
  setChatbotOption,
  cancelOption,
  errors
}) => {
  const optionTextRef = useRef(null);

  const renderIconWithText = () => {
    const option = iconMapping[chatbotOption.option_type];

    if (option) {
      return (
        <>
          <IconMC name={option.iconName} size="base" className="tw-mr-2 tw-text-gray-500" />
          <span className="tw-text-sm tw-text-gray-500">{option.text}</span>
        </>
      );
    }

    return <div className="tw-h-5" />;
  };

  const handleInputChange = (e) => {
    const { target } = e;
    const { name } = target;
    const value = target.type === 'checkbox' ? target.checked : target.value;

    setChatbotOption({
      ...chatbotOption,
      [name]: value
    });
  };

  const setFocus = () => {
    optionTextRef.current.focus();
  };

  return (
    <div className="tw-flex-shrink-0 tw-border-b tw-bg-white tw-px-6 tw-py-3">
      <div className="tw-flex tw-flex-col">
        <div className="tw-flex tw-items-center">
          {renderIconWithText()}
        </div>
        <div className="tw-mt-1 tw-flex tw-items-center tw-justify-between tw-gap-4">
          <div className="tw-min-w-0 tw-flex-1">
            <div className="tw-flex tw-items-center tw-gap-2">
              <input
                ref={optionTextRef}
                type="text"
                className="tw-min-w-0 tw-flex-1 tw-border-0 tw-bg-transparent tw-text-lg tw-font-semibold tw-text-gray-600 focus:tw-outline-none"
                value={chatbotOption.text}
                onChange={handleInputChange}
                name="text"
                aria-invalid={Boolean(errors.text)}
              />
              <button
                type="button"
                className="tw-flex-shrink-0 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
                onClick={setFocus}
                aria-label="Editar"
              >
                <IconMC name="edit-outline" size="xl" className="tw-text-gray-700" />
              </button>
            </div>
            {errors.text && (
              <span className="tw-mt-1 tw-block tw-text-xs tw-text-red-500">{errors.text}</span>
            )}
          </div>
          <button
            type="button"
            className="tw-flex-shrink-0 tw-cursor-pointer tw-border-0 tw-bg-transparent tw-p-0"
            onClick={cancelOption}
            aria-label="Cerrar"
          >
            <IconMC name="close-outline" size="2xl" className="tw-cursor-pointer" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepHeader;
